module.exports = __webpack_public_path__ + "static/media/zf_1.f1abe737.jpg";